import React, { useRef, useEffect } from 'react';
import DesignCustomizer from './DesignCustomizer';
import ModalPageTwo from './ModalPageTwo';
import ModalPageThree from './ModalPageThree';

function Modal(props) {
  const modalRef = useRef(null);

  // Helper function to check if there are any designs
  const hasDesigns = () => {
    // Check for legacy design
    if (props.formData.design) return true;

    // Check for designs in customization
    if (props.formData.designCustomization) {
      // Check design pool
      if (
        props.formData.designCustomization.designPool &&
        props.formData.designCustomization.designPool.length > 0
      ) {
        return true;
      }

      // Check side designs
      if (props.formData.designCustomization.sideDesigns) {
        const {
          front = [],
          back = [],
          side = [],
        } = props.formData.designCustomization.sideDesigns;
        if (front.length > 0 || back.length > 0 || side.length > 0) {
          return true;
        }
      }
    }

    return false;
  };
  useEffect(() => {
    const handleClickOutside = event => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        // Give DesignCustomizer a moment to save state
        setTimeout(() => {
          props.closeModal();
        }, 50);
      }
    };

    const handleKeyDown = event => {
      if (event.key === 'Escape') {
        // Give DesignCustomizer a moment to save state
        setTimeout(() => {
          props.closeModal();
        }, 50);
      }
    };

    if (props.isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
      document.addEventListener('keydown', handleKeyDown);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [props, props.isOpen, props.closeModal]);

  function scrollToTop() {
    if (modalRef.current) {
      modalRef.current.scrollTop = 0;
    }
  }

  useEffect(scrollToTop, [props.modalStepNumber]);
  if (!props.isOpen) return null;

  function handleBack() {
    props.setModalStepNumber(Math.max(props.modalStepNumber - 1, 1));
  }

  return (
    <div className="wizard-modal-wrapper">
      <div className={`wizard-modal ${(props.modalStepNumber === 1 || (props.modalStepNumber === 2 && hasDesigns())) ? 'wizard-modal-with-customizer' : ''} ${((props.modalStepNumber === 2 && !hasDesigns()) || props.modalStepNumber === 3) ? 'wizard-modal-with-page-two' : ''}`} ref={modalRef}>
        <button
          className="wizard-close-button"
          type="button"
          onClick={() => {
            // Give DesignCustomizer a moment to save state
            setTimeout(() => {
              props.closeModal();
            }, 50);
          }}
        >
          <span className="is-hidden-visually">Close</span>
        </button>
        {props.modalStepNumber === 1 && (
          <DesignCustomizer
            modalStepNumber={props.modalStepNumber}
            setModalStepNumber={props.setModalStepNumber}
            handleStartOver={props.handleStartOver}
            handleRemoveDesign={props.handleRemoveDesign}
            handleRemoveProduct={props.handleRemoveProduct}
            formData={props.formData}
            handleChange={props.handleChange}
            handleBack={handleBack}
            productGalleryUrl={props.productGalleryUrl}
            designGalleryUrl={props.designGalleryUrl}
          />
        )}
        {props.modalStepNumber === 2 && (
          <ModalPageTwo
            modalStepNumber={props.modalStepNumber}
            setModalStepNumber={props.setModalStepNumber}
            handleBack={handleBack}
            schools={props.schools}
            handleChange={props.handleChange}
            handleSubmitQuoteRequest={props.handleSubmitQuoteRequest}
            formData={props.formData}
            recaptchaKey={props.recaptchaKey}
          />
        )}
        {props.modalStepNumber === 3 && (
          <ModalPageThree 
            formData={props.formData}
            modalStepNumber={props.modalStepNumber}
            setModalStepNumber={props.setModalStepNumber}
            previewUrl={props.previewUrl}
          />
        )}
      </div>
    </div>
  );
}

export default Modal;
